export class Show {
    name: string | null
    networkName: string | null
    productionCompany: string | null
    publicRouteUrL: string | null
    termsAndConditions: string | null
    defaultTicketingStartTimeOffsetTicks: number | null 
    //TODO Replace dummy test data with real input fields when refactoring the create module
    constructor() {
        this.name = ''
        this.networkName = 'test'
        this.productionCompany = 'test'
        this.publicRouteUrL = 'test'
        this.termsAndConditions = 'test'
        this.defaultTicketingStartTimeOffsetTicks = 0
    }
}